import { useEffect } from 'react';
import swal from 'sweetalert';
import { useAlert } from 'hooks';

const AlertModal = () => {
  const { successMessage, errorMessage } = useAlert();

  const alertType = successMessage ? 'success' : 'error';
  const message = successMessage || errorMessage;

  useEffect(() => {
    if (successMessage || errorMessage) swal('', message, alertType);
  }, [successMessage, errorMessage]);

  return null;
};

export default AlertModal;
